// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InstrumentSpecificType;
(function (InstrumentSpecificType) {
    InstrumentSpecificType[InstrumentSpecificType["ContinuousContract"] = 0] = "ContinuousContract";
    InstrumentSpecificType[InstrumentSpecificType["None"] = 1] = "None";
})(InstrumentSpecificType || (InstrumentSpecificType = {}));
